import { ThemeColor } from "@punks/core"
import React from "react"
import { useAppSelector } from "../../../../../../state/store"
import CustomButton from "../../../../../../ui/atoms/Button"
import { formatMoney } from "../../../../../../utils/money"
import { useLabels } from "../../../../../contents/hooks"
import { Basket } from "../../../../state/checkoutTypes"
import classes from "./PurchaseCta.module.css"

interface Props {
  basket: Basket
  loading?: boolean
  onNext: () => void
  label?: string
  color?: ThemeColor
}

const PurchaseCta = ({ basket, loading, onNext, label, color }: Props) => {
  const { getLabel } = useLabels()
  const { loading: checkoutLoading } = useAppSelector((state) => state.checkout)

  return (
    <CustomButton
      fullWidth
      size="small"
      color={color ?? "secondary"}
      onClick={onNext}
      className={classes.button}
      loading={loading || checkoutLoading}
      invariantCase={!!label}
    >
      {label || (
        <>
          {getLabel("basket", "basket-next")}{" "}
          {formatMoney({
            amount: basket.recap.subtotal.price,
            currency: "eur",
          })}
        </>
      )}
    </CustomButton>
  )
}

export default PurchaseCta
